import { revertDeviceModel } from '@/shared/lib';
import _ from 'lodash';
import { createClient } from '@/shared/api';
import type {
  CountCallCenterStudiesQuery,
  CountCallCenterStudiesQueryVariables,
} from '@/shared/api';
import TICKET_COUNT_AWAITING_UPLOAD_DEVICES_QUERY from '../queries/ticketCountAwaitingUploadDevices';

/**
 * Counts the awaiting-upload call-center studies matching a filter so the tab badge can be rendered. Deep-clones the filter and rewrites its model to the legacy identifier, queries TICKET_COUNT_AWAITING_UPLOAD_DEVICES_QUERY, and throws the first GraphQL error message when no count came back.
 *
 * @param filter - Filter criteria, whose model is converted to its legacy name.
 * @returns Promise resolving to the awaiting-upload study count.
 */
const fetchTicketCountAwaitingUploadDevices = async (
  filter: CountCallCenterStudiesQueryVariables['filter'],
): Promise<CountCallCenterStudiesQuery['countCallCenterStudies']> => {
  const client = createClient();
  const clonedFilter = _.cloneDeep(filter);
  if (!_.isEmpty(clonedFilter)) {
    clonedFilter.model = revertDeviceModel(clonedFilter.model);
  }
  const countCallCenterStudiesResult = await client.query<
    CountCallCenterStudiesQuery,
    CountCallCenterStudiesQueryVariables
  >({
    query: TICKET_COUNT_AWAITING_UPLOAD_DEVICES_QUERY,
    variables: {
      filter: clonedFilter,
    },
  });
  const { data, errors } = countCallCenterStudiesResult;
  const { countCallCenterStudies } = data;

  if (_.isNil(countCallCenterStudies) && errors?.length) {
    throw new Error(errors[0].message);
  }

  return countCallCenterStudies;
};

export default fetchTicketCountAwaitingUploadDevices;
